import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["card", "radio"]

  connect() {
    // Highlight the initially selected card
    this.radioTargets.forEach(radio => {
      if (radio.checked) {
        radio.closest('.card').classList.add('border-primary')
      }
    })
  }

  select(event) {
    // Remove selected state from all cards
    this.cardTargets.forEach(card => card.classList.remove('border-primary'))
    
    // Add selected state to clicked card
    event.currentTarget.classList.add('border-primary')
    
    // Find and check the radio button
    const radio = event.currentTarget.querySelector('input[type="radio"]')
    if (radio) radio.checked = true
  }
} 
